import { fetcher } from '../../utility/domUtils';
import { transformClientFormatToServer } from '../lib/campaignsModel';
import _get from 'lodash/get';

export const INITIALIZE_WIZARD = 'CAMPAIGNS_INITIALIZE_WIZARD';
export const INITIALIZE_DESCRIPTION = 'INITIALIZE_DESCRIPTION';
export const WIZARD_CONTINUE = 'CAMPAIGNS_WIZARD_CONTINUE';
export const WIZARD_BACK = 'CAMPAIGNS_WIZARD_BACK';
export const CAMPAIGNS_BUSY = 'CAMPAIGNS_BUSY';
export const GET_CAMPAIGN_DATA_SUCCESS = 'GET_CAMPAIGN_DATA_SUCCESS';
export const GET_CAMPAIGN_DATA_ERROR = 'GET_CAMPAIGN_DATA_ERROR';
export const CREATE_CAMPAIGN_SUCCESS = 'CREATE_CAMPAIGN_SUCCESS';
export const CREATE_CAMPAIGN_ERROR = 'CREATE_CAMPAIGN_ERROR';
export const EDIT_CAMPAIGN_SUCCESS = 'EDIT_CAMPAIGN_SUCCESS';
export const EDIT_CAMPAIGN_ERROR = 'EDIT_CAMPAIGN_ERROR';
export const BANNER_ERROR = 'BANNER_ERROR';
export const LOGO_ERROR = 'LOGO_ERROR';
export const RICH_EDITOR_ERROR = 'RICH_EDITOR_ERROR';
export const WIZARD_SET_CURRENT_PAGE = 'WIZARD_SET_CURRENT_PAGE';
export const OPEN_MOBILE_PREVIEW = 'OPEN_MOBILE_PREVIEW';
export const CLOSE_MOBILE_PREVIEW = 'CLOSE_MOBILE_PREVIEW';
export const DRAFT_CAMPAIGNS_BUSY = 'DRAFT_CAMPAIGNS_BUSY';
export const IS_DRAFT_CAMPAIGN = 'IS_DRAFT_CAMPAIGN';

export function initializeWizard(campaign) {
  return {
    type: INITIALIZE_WIZARD,
    payload: campaign,
  };
}

export function initializeDescription(description) {
  return {
    type: INITIALIZE_DESCRIPTION,
    payload: description,
  };
}

export function goToNextStep() {
  return {
    type: WIZARD_CONTINUE,
  };
}

export function goToPreviousStep() {
  return {
    type: WIZARD_BACK,
  };
}

export function setCurrentStep(stepNumber) {
  return {
    type: WIZARD_SET_CURRENT_PAGE,
    payload: stepNumber,
  };
}

export function updateBannerError(value) {
  return {
    type: BANNER_ERROR,
    payload: {
      error: value,
    },
  };
}

export function updateLogoError(value) {
  return {
    type: LOGO_ERROR,
    payload: {
      error: value,
    },
  };
}

export function updateRichEditorError(value) {
  return {
    type: RICH_EDITOR_ERROR,
    payload: {
      error: value,
    },
  };
}

export function busy() {
  return {
    type: CAMPAIGNS_BUSY,
  };
}

export function draftBusy() {
  return {
    type: DRAFT_CAMPAIGNS_BUSY,
  };
}

export function getCampaign(id, isDuplicated) {
  return (dispatch) => {
    dispatch(busy());

    let resParams = {};
    return fetcher(`/donate/api/campaigns/${id}`, {
      method: 'GET',
    })
      .then((response) => {
        resParams = {
          ...resParams,
          status: response.status,
          statusText: response.statusText,
          ok: response.ok,
        };
        return response.json();
      })
      .then((responseJson) => {
        if (!resParams.ok) {
          const error = {
            responseJSON: responseJson,
            ...resParams,
          };
          dispatch({
            type: GET_CAMPAIGN_DATA_ERROR,
            payload: { error },
          });

          return error;
        }
        const campaign = _get(responseJson, 'campaign');

        dispatch({
          type: GET_CAMPAIGN_DATA_SUCCESS,
          payload: { campaign, isDuplicated },
        });

        return { ...responseJson, ok: resParams.ok };
      })
      .catch((error) => {
        dispatch({
          type: GET_CAMPAIGN_DATA_ERROR,
          payload: { error },
        });

        return error;
      });
  };
}

export function saveCampaign(campaignData) {
  return (dispatch) => {
    if (campaignData.id) {
      return dispatch(updateCampaign(campaignData));
    }
    return dispatch(createCampaign(campaignData));
  };
}

function createCampaign(campaignData) {
  const campaignDataServer = transformClientFormatToServer(campaignData);
  return (dispatch) => {
    if (campaignData.status === 'DRAFT') {
      dispatch(draftBusy());
    } else {
      dispatch(busy());
    }

    let resParams = {};
    return fetcher('/donate/api/campaigns', {
      method: 'POST',
      body: JSON.stringify({
        campaignData: campaignDataServer,
      }),
    })
      .then((response) => {
        resParams = {
          ...resParams,
          ok: response.ok,
        };
        return response.json();
      })
      .then((responseJson) => {
        if (!resParams.ok) {
          const error = {
            responseJSON: responseJson,
            ...resParams,
          };
          dispatch({
            type: CREATE_CAMPAIGN_ERROR,
            payload: {
              error,
            },
          });
          return error;
        }
        const campaign = _get(responseJson, 'campaign');
        dispatch({
          type: CREATE_CAMPAIGN_SUCCESS,
          payload: campaign,
        });
        return { ...responseJson, ok: resParams.ok };
      })
      .catch((error) => {
        dispatch({
          type: CREATE_CAMPAIGN_ERROR,
          payload: {
            error,
          },
        });
        return error;
      });
  };
}

function updateCampaign(campaignData) {
  const campaignDataServer = transformClientFormatToServer(campaignData);

  return (dispatch) => {
    if (campaignData.status === 'DRAFT') {
      dispatch(draftBusy());
    } else {
      dispatch(busy());
    }

    let resParams = {};
    return fetcher(`/donate/api/campaigns/${campaignData.id}`, {
      method: 'PUT',
      body: JSON.stringify({
        campaignData: campaignDataServer,
      }),
    })
      .then((response) => {
        resParams = {
          ...resParams,
          status: response.status,
          statusText: response.statusText,
          ok: response.ok,
        };
        return response.json();
      })
      .then((responseJson) => {
        if (!resParams.ok) {
          const error = {
            responseJSON: responseJson,
            ...resParams,
          };
          dispatch({
            type: EDIT_CAMPAIGN_ERROR,
            payload: {
              error,
            },
          });
          return error;
        }
        const campaign = _get(responseJson, 'campaign');
        dispatch({
          type: EDIT_CAMPAIGN_SUCCESS,
          payload: campaign,
        });
        return { ...responseJson, ok: resParams.ok };
      })
      .catch((error) => {
        dispatch({
          type: EDIT_CAMPAIGN_ERROR,
          payload: {
            error,
          },
        });
        return error;
      });
  };
}

export function openMobilePreview() {
  return {
    type: OPEN_MOBILE_PREVIEW,
  };
}

export function closeMobilePreview() {
  return {
    type: CLOSE_MOBILE_PREVIEW,
  };
}

export function isDraftCampaign(value) {
  return {
    type: IS_DRAFT_CAMPAIGN,
    payload: value,
  };
}
